// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Help: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M21,0.17C9.5,0.17,0.17,9.5,0.17,21S9.5,41.83,21,41.83S41.83,32.5,41.83,21
	S32.5,0.17,21,0.17z M23.08,35.58h-4.17v-4.17h4.17V35.58z M27.4,19.44l-1.88,1.92c-1.5,1.52-2.44,2.77-2.44,5.9h-4.17v-1.04
	c0-2.29,0.94-4.38,2.44-5.9l2.58-2.62c0.77-0.75,1.23-1.79,1.23-2.94c0-2.29-1.88-4.17-4.17-4.17c-2.29,0-4.17,1.88-4.17,4.17h-4.17
	c0-4.6,3.73-8.33,8.33-8.33c4.6,0,8.33,3.73,8.33,8.33C29.33,16.58,28.58,18.25,27.4,19.44z"/>
</svg>;
};

export default React.memo(Help);
